import {FC, useMemo} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'

interface Props {}

export const InputNote: FC<Props> = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {orderItem, soItem} = useAppSelector(soSelector)

  const defaultValue = useMemo(() => orderItem?.notes ?? '', [orderItem])

  const handleChange = (value: string) => {
    dispatch(setSoItem({...soItem, notes: value}))
  }

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>{t('sub-order-catatan')}</Form.Label>
      </Col>
      <Col md={8}>
        <Form.Control
          size='sm'
          placeholder={t('sub-order-catatan')}
          type='text'
          as='textarea'
          defaultValue={defaultValue}
          onChange={(e: any) => handleChange(e.target.value as string)}
        />
      </Col>
    </Row>
  )
}
